<template>
	<v-snackbar class="switcher" timeout="-1" elevation=0 light top flat left  app vertical value="true">
		<div class="text-center overline">SHOW</div>
		<v-tabs vertical slider-color="primary" background-color='secondary' light  elevation=4 v-model="isAdminMode">
			<v-tab >Public Pages</v-tab>
			<v-tab>Admin Pages</v-tab>
		</v-tabs>

	</v-snackbar>
</template>

<script>
export default {
	name: 'AdminPageSwitcher',
	props: {
		value: Boolean
	},
	computed: {
		isAdminMode: {
			get() {
				const tabIndex = (this.value == true) ? 1 : 0
				return tabIndex
			},
			set(tabIndex) {
				const value = tabIndex == 1 ? true : false
				this.$emit('input', value)
			}
		}
	}
}
</script>

<style >
.switcher .v-snack__wrapper {
	min-width: auto !important;
	min-height: auto !important;
	background-color: rgba(255, 255, 255, 0.6) !important;
}

.switcher .v-snack__wrapper .v-snack__content {

}
</style>
